// @ts-strict-ignore
import type {Section, SectionItem} from 'common/components/items-menu/types';
import {DisplaySize} from 'common/components/tooltip/types';
import {MATH_TYPE, NUMERIC_MATH_TYPES, PRIMITIVE_MATH_TYPES} from 'common/types/reports/bookmark';
import {EventPropertyAggregations} from 'common/query-builder/query-entry-section/constants';
import {SelectorTypeAggregation} from 'common/query-builder/query-entry-section/types';

const mapAggregation = (items: SelectorTypeAggregation[]): SectionItem[] => {
  return items.map((item) => ({
    label: item.label({}),
    value: item,
    tooltip: {
      text: item.description?.({}),
      size: DisplaySize.Small,
    },
  }));
};

const DISABLED_BEHAVIOR_MATH_TYPES = new Set<MATH_TYPE>([
  ...Object.values(NUMERIC_MATH_TYPES),
  PRIMITIVE_MATH_TYPES.FIRST_VALUE,
  PRIMITIVE_MATH_TYPES.MEDIAN,
  PRIMITIVE_MATH_TYPES.MOST_FREQUENT,
]);

/**
 * Defines aggregation sections for Behaviors
 */
export const BehavioralAggregationSections: Section[] = [
  {
    label: ({t}) => t(`query-builder.property-agg.menu-label`),
    items: mapAggregation(
      EventPropertyAggregations.filter((aggregation) => !DISABLED_BEHAVIOR_MATH_TYPES.has(aggregation.operator)),
    ),
  },
];
